module.exports = __webpack_public_path__ + "static/media/Img_8.754bbb8f.JPG";